const additionalGroupsKeys = {
  module: ['additionalGroups'] as const,
  list: () => [...additionalGroupsKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...additionalGroupsKeys.list(), filters] as const,
  details: (id: string) =>
    [...additionalGroupsKeys.module, 'details', id] as const,
  additionals: (id: string) =>
    [...additionalGroupsKeys.module, id, 'additionals'] as const,
};

export default additionalGroupsKeys;
